export const contractTypeOptions = [
  {
    label: "Escritório privativo",
    value: "po",
  },
  ...(import.meta.env.VITE_WOBA_INVENTORY_RELEASED === "false"
    ? [
        {
          label: "BTS",
          value: "bts",
        },
      ]
    : [
        {
          label: "Serviço extra",
          value: "extra-service",
        },
      ]),
  {
    label: "Endereço fiscal",
    value: "tax_address",
  },
  {
    label: "Posição fixa",
    value: "fixed_position",
  },
];

export type PoType = "pronto" | "personalizado" | "sob_medida";

export const poTypeOptions: { label: string; value: PoType; id: string }[] = [
  { label: "Pronto", value: "pronto", id: "po-type-pronto" },
  {
    label: "Personalizado",
    value: "personalizado",
    id: "po-type-personalizado",
  },
  { label: "Sob medida", value: "sob_medida", id: "po-type-sob-medida" },
];

export const getPoTypeLabel = (value: PoType | undefined): string | undefined =>
  poTypeOptions.find((o) => o.value === value)?.label;

export const renewalIndicatorOptions = [
  {
    label: "IGP-M",
    value: "IGP-M",
  },
  {
    label: "IPCA",
    value: "IPCA",
  },
];
